/* eslint-disable no-useless-computed-key */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PurchaseIcon from "../../../../../assets/images/icon_menus/PurchaseIcon.json";
import clsx from "clsx";
import { Col, Image, Row, Space, Modal } from "antd";
import {
    Button, TextField, Box, Switch, InputLabel, Checkbox, TableRow, TableCell, Typography, Tooltip, InputAdornment, FormControlLabel
} from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { useDispatch, useSelector } from "react-redux";
import gstActions from "../../../../Admin/Setup/redux/actions";
import actions from "../../redux/actions";
import transactionsActions from "../../../Transactions/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import moment from 'moment';
import { capitalizeFirstLetter, currencyFormat, checkCRUDViewPermission, checkCRUDPermission, scrollToError, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import { selectPurchaseInvoiceHead } from "../../../../../config/constant";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import IconButton from '@mui/material/IconButton';
import CustomAlert from "../../../../Shared/components/CustomAlert";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import { useEventListener } from "../../../../../helpers/useEventListener";
import { CustomModal } from "../../../../Shared/components/DeleteModal";

const SupplierPaymentCreate = (props) => {
    const { supplierDetails } = useSelector(state => state.purchaseManagementReducer);
    const { purchaseInvoiceDetails, loader } = useSelector(state => state.purchaseTransactionsReducer);
    const { currencyDetails, mopDetails } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, createData } = useSelector(state => state.crudReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selected, setSelected] = useState([]);
    const childRef = useRef('');
    const [paymentDate, setPaymentDate] = useState(new Date());
    const [mopId, setMopId] = useState('');
    const [amount, setAmount] = useState(0);
    const [hiddenAmount, setHiddenAmount] = useState(0);
    const [currencyId, setCurrencyId] = useState('');
    const [reference, setReference] = useState('');
    const [status, setStatus] = useState('CREATED');
    const [description, setDescription] = useState('');
    const [paymentAmount, setPaymentAmount] = useState(0.00);
    const [balanceAmount, setBalanceAmount] = useState(0.00);
    const [markedAmount, setMarkedAmount] = useState(0.00);
    const [errorSupplierId, setErrorSupplierId] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    const [errorMopId, setErrorMopId] = useState(false);
    const [errorAmount, setErrorAmount] = useState(false);
    const [errorDate, setErrorDate] = useState(false);
    const [autoMark, setAutoMark] = useState(false);
    const [supplierChange, setSupplierChange] = useState(false);
    const [errorCommon, setErrorCommon] = useState(false);
    const dispatch = useDispatch();

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { history, onRequestSort, sortOrder, sortBy } = props;
    const { paymentSupplierId, invoiceId } = useParams();

    const decryptedId = AESDecrypt(paymentSupplierId);

    const [supplierId, setSupplierId] = useState('');
    const [supplierSerialNo, setSupplierSerialNo] = useState('');
    const { roleManagement } = useSelector(state => state.authReducer);
    const [confirm, setConfirm] = useState(false);


    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Supplier Payment', 'create', history, 'Purchase')) {
            loadTasks();
        }

        return () => {
            dispatch({ type: transactionsActions.CLEAR_PURCHASE_TRANSACTION_DETAILS_START });
            dispatch({ type: actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START });
        }
    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            handleSubmit(e);
        } else if (confirm) {
            handleSubmit('', 'CONFIRMED');
        } else if (e.altKey && e.keyCode === 79) {
            e.preventDefault();
            handleConfirmSubmit();
        }
    };
    useEventListener("keydown", handleKeyDown);

    const emptyState = () => {
        setErrorSupplierId(false);
        setErrorCurrency(false);
        setErrorMopId(false);
        setErrorAmount(false);
        setErrorCommon(false);
    }

    const loadTasks = useCallback(() => {
        if (paymentSupplierId !== undefined && decryptedId !== 0) {
            supplierApi('', decryptedId);
        } else {
            supplierApi();
        }
        // dispatch({
        //     type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile', filter: {
        //         order: 'id desc'
        //     }
        // });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
    });


    const supplierApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: actions.SUPPLIER_DETAILS_START, url: 'supplierProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 100,
                skip: 0
            },
        });
    }


    useEffect(() => {
        if (paymentSupplierId !== undefined && decryptedId !== 0 && supplierDetails !== '' && supplierDetails?.length > 0 && !supplierChange) {
            let a = supplierDetails.filter(function (el) { return el.id === parseInt(decryptedId) });
            if (a && a?.length > 0 && a[0]?.isHold) {
                toast.error('Please release the Supplier from ON-HOLD to allow for transaction to be created.');
                history.push("/purchase/purchase-management/all-suppliers");
            }
            handleChangeSupplier((parseInt(decryptedId)));
        }
    }, [supplierDetails]);

    const handleConfirmSubmit = () => {
        childRef?.current?.handleAdjustHeight();
        let emptySupplier = emptyValidation('Supplier Name', supplierId, 'dropDown');
        let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptySupplier.isValid && emptyMopId.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            setConfirm(true);
        } else {
            setConfirm(false);
            if (emptySupplier.errors) {
                setErrorSupplierId(emptySupplier.errors);
            }
            if (emptyMopId.errors) {
                setErrorMopId(emptyMopId.errors);
            }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    }


    const handleSubmit = (e = '', status = 'CREATED') => {
        if (e !== '') {
            e?.preventDefault();
        }

        childRef?.current?.handleAdjustHeight();
        let emptySupplier = emptyValidation('Supplier Name', supplierId, 'dropDown');
        let emptyMopId = emptyValidation('Method of payment', mopId, 'dropDown');
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        let emptyAmount = emptyValidation('Amount', hiddenAmount);
        let emptyDate = emptyValidation('Date', paymentDate);
        emptyState();
        if (emptySupplier.isValid && emptyMopId.isValid && emptyCurrencyId.isValid && emptyAmount.isValid && emptyDate.isValid) {
            setStatus(status);
            let sItems = [];
            let mItems = '';
            var items = purchaseInvoiceDetails.filter((el) => { return selected.find(e => e === el.id) });
            items && items.length > 0 && items.map((element, i) => {
                mItems = {
                    purchaseInvoiceId: element.id,
                    amountToSettle: parseFloat(element.costAmount),
                    fullySettled: (parseFloat(parseFloat(element.costAmount).toFixed(2)) === parseFloat(parseFloat(element.invoiceAmount - element.settledAmount).toFixed(2))) ? true : false
                };
                sItems.push(mItems);
            });
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'supplierPayment',
                title: 'Supplier Payment',
                details: {
                    supplierId: supplierId,
                    date: paymentDate,
                    paymentAmount: parseFloat(parseFloat(hiddenAmount).toFixed(2)),
                    reference: reference,
                    paymentStatus: status,
                    description: description,
                    mopId: mopId,
                    currencyId: currencyId,
                    markedAmount: parseFloat(parseFloat(markedAmount).toFixed(2)),
                    items: sItems
                }
            })
        } else {
            setConfirm(false);
            if (emptySupplier.errors) {
                setErrorSupplierId(emptySupplier.errors);
            }
            if (emptyMopId.errors) {
                setErrorMopId(emptyMopId.errors);
            }
            if (emptyCurrencyId.errors) {
                setErrorCurrency(emptyCurrencyId.errors);
            }
            if (emptyAmount.errors) {
                setErrorAmount(emptyAmount.errors);
            }
            if (emptyDate.errors) {
                setErrorDate(emptyDate.errors);
            }
            scrollToError();
        }
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            setConfirm(false);
            //toast(createDetails);
            if (roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'view', 'Purchase')) {
                if (paymentSupplierId || invoiceId) {
                    history.push(`/purchase/purchase-management/supplier-payment/${AESEncrypt(createData.id)}/${AESEncrypt(paymentSupplierId || invoiceId)}/view`, 'create');
                } else {
                    history.push(`/purchase/purchase-management/supplier-payment/${AESEncrypt(createData.id)}/view`, 'create');
                }
            } else {
                history.push(`/purchase/purchase-management/supplier-payment`);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    const handleChangeSupplier = (id) => {
        let cId = id;
        setAutoMark(false);
        let a = supplierDetails && supplierDetails.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            if (a[0].isHold) {
                cId = 0;
                setSupplierId('');
                setMopId('');
                setCurrencyId('');
                setSupplierSerialNo('');
                setErrorSupplierId('Please release the Supplier Invoice from ON-HOLD to allow for transaction to be processed.');
            } else {
                setSupplierId(cId);
                setMopId(a[0].mopId > 0 ? a[0].mopId : '');
                setCurrencyId(a[0].currencyId && a[0].currencyId);
                setSupplierSerialNo(a[0]?.serialNo);
            }
        }

        let filter = { ["and"]: [{ supplierId: cId }, { source: 'PURCHASE SELF BILL' }, { isSettled: false }] };
        dispatch({
            type: transactionsActions.PURCHASE_INVOICE_DETAILS_START,
            url: 'purchaseInvoice',
            filter: {
                where: filter,
                order: 'invoiceDate ASC',
            }
        });
        setSelected([]);
        setSupplierChange(true);
    }

    useEffect(() => {
        calculatePaymentTotal(purchaseInvoiceDetails ? purchaseInvoiceDetails : [], hiddenAmount);
    }, [supplierId]);

    const handleClick = (e, data, invoiceId) => {
        if (e.target.checked) {
            if (amount > 0) {

            } else {
                toast.dismiss();
                toast.error('Amount less than invoice amount');
                return false;
            }
        }
        setAutoMark(false);
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, data.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
        calculatePayment(e, data, invoiceId, newSelected);
    };

    const calculatePayment = (e, data, invoiceId, selected) => {
        let mLines = [];
        for (const [key, value] of Object.entries(data)) {
            mLines[key] = value
        }
        let tAmount = 0;
        let autoAmount = parseFloat(amount);
        if (e.target.name === 'auto') {
            let autoMarkDiv = document.getElementById('autoMark');
            autoAmount = autoMarkDiv.getAttribute('dataamount');
        }
        let selectedArray = [];
        if (e.target.name === 'costAmount' && e.target.value !== '') {
            if (parseFloat(e.target.value) <= parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) {
                mLines['costAmount'] = parseFloat(parseFloat(e.target.value).toFixed(2));
            } else {
                mLines['costAmount'] = parseFloat(parseFloat(parseFloat(data.invoiceAmount) - parseFloat(data.settledAmount)).toFixed(2));
            }
        } else {
            if (e.target.checked) {
                if (autoAmount > (data.invoiceAmount - data.settledAmount)) {
                    mLines['costAmount'] = parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2));
                    tAmount = parseFloat(autoAmount - parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)));
                } else {
                    mLines['costAmount'] = parseFloat(parseFloat(autoAmount).toFixed(2));
                    tAmount = parseFloat(parseFloat(autoAmount - autoAmount).toFixed(2));
                }
            } else {
                tAmount = parseFloat(parseFloat(autoAmount + data.costAmount).toFixed(2));
                mLines['costAmount'] = 0;
            }
        }
        let index = purchaseInvoiceDetails.findIndex((d, i) => invoiceId === i);
        if (index >= 0) {
            purchaseInvoiceDetails.splice(index, 1, mLines);
        }

        if (e.target.name === 'costAmount' && e.target.value !== '') {
            selectedArray = purchaseInvoiceDetails.filter(function (el) { return selected.find(e => e === el.id) });
            let tcAmount = parseFloat(selectedArray.reduce((a, v) => a = parseFloat(a) + parseFloat(v.costAmount), 0));
            tAmount = parseFloat(hiddenAmount) - parseFloat(tcAmount);
            if (hiddenAmount < tcAmount) {
                toast.dismiss();
                toast('Payment available only Rs.' + hiddenAmount);
                mLines['costAmount'] = parseFloat(data.costAmount);
                purchaseInvoiceDetails.splice(index, 1, mLines);
                return false;
            }
        }
        calculatePaymentTotal(purchaseInvoiceDetails, tAmount);
    }

    const calculatePaymentTotal = (purchaseInvoiceDetails, a) => {
        //let paymentAmount = salesInvoiceDetails ? parseFloat(salesInvoiceDetails.reduce((a, v) => a = a + v.invoiceAmount, 0)) : 0.00;
        let markedAmount = purchaseInvoiceDetails ? purchaseInvoiceDetails.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v.costAmount)), 0) : 0.00;
        setPaymentAmount(hiddenAmount);
        setMarkedAmount(markedAmount);
        setBalanceAmount(parseFloat(parseFloat(parseFloat(hiddenAmount).toFixed(2)) - markedAmount));
        setAmount(a);
    }

    const handleCostAmount = (e, data, costIndex) => {
        setAutoMark(false);
        calculatePayment(e, data, costIndex, selected);
    }

    const handleAmount = (value) => {
        setAmount(value);
        setHiddenAmount(value);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if (invoiceId !== undefined && purchaseInvoiceDetails?.length > 0) {
            let index = purchaseInvoiceDetails.findIndex((d, i) => parseInt(invoiceId) === d.id);
            let data = purchaseInvoiceDetails.filter(function (el) { return el.id === parseInt(invoiceId) });
            if (data.length) {
                //  let amount = data[0].invoiceAmount ? data[0].invoiceAmount - data[0].settledAmount : 0;
                let amount = parseFloat(data[0].balanceAmount); // ? data[0].invoiceAmount - data[0].settledAmount : 0;
                setAmount(amount);
                setHiddenAmount(amount);
                setTimeout(() => {
                    const element = document.getElementById(`checkbox_${index}`);
                    if (element !== null && !element.checked) {
                        element.click();
                    }
                }, 100);
            }
        }
        childRef?.current?.handleAdjustHeight();
    }, [purchaseInvoiceDetails]);

    const handleAutomark = (e) => {
        setAutoMark(e.target.checked);
        let newSelected = [];
        resetSelected();
        if (e.target.checked) {
            purchaseInvoiceDetails && purchaseInvoiceDetails.length > 0 && purchaseInvoiceDetails.map((data, i) => {
                let e = { 'target': { 'name': "auto", "checked": true } };
                setTimeout(function () {
                    if (data.onHold) {
                        return false;
                    }
                    let autoMarkDiv = document.getElementById('autoMark');
                    if (autoMarkDiv.getAttribute('dataamount') > 0) {

                    } else {
                        return false;
                    }
                    newSelected.push(data.id);
                    calculatePayment(e, data, i, newSelected);
                });
            });
        }
        setSelected(newSelected);
    }

    const resetSelected = () => {
        purchaseInvoiceDetails && purchaseInvoiceDetails.length > 0 && purchaseInvoiceDetails.map((data, si) => {
            let mLines = [];
            for (const [key, value] of Object.entries(data)) {
                mLines[key] = value
            }
            mLines['costAmount'] = 0;
            let index = purchaseInvoiceDetails.findIndex((d, i) => si === i);
            if (index >= 0) {
                purchaseInvoiceDetails.splice(index, 1, mLines);
            }
        });
        setPaymentAmount(0);
        setMarkedAmount(0);
        setBalanceAmount(0);
        setAmount(hiddenAmount);
    }

    const handleUnAutomark = (e) => {
        e.target.checked = false;
        handleAutomark(e);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={PurchaseIcon} title={'Purchase'} links={[{ 'label': 'Purchase', 'link': '/purchase' }, { 'label': 'Supplier Payments', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Make Payment'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={false}
                        index={0}
                        ref={childRef}
                        component={
                            <Box
                                className={clsx(classes.removeUnderline)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}>
                                <Row gutter={50} className={clsx(classes.ButtonRelative)}>
                                    {
                                        errorCommon && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <CustomAlert error={errorCommon} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                        </Col>
                                    }
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={24} xs={24}>
                                        <Typography variant={'h6'} className={clsx(classes.bold, classes.disInline)}>VP ---</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={14}>
                                        <span className={clsx(classes.statusButton, classes.thirdBox, classes.disInline)}>{capitalizeFirstLetter('CREATED')}</span>
                                    </Col>
                                    <Col xxl={14} xl={14} lg={12} md={8} sm={12} xs={10} className={clsx(classes.thirdBox, classes.textAlignRight, classes.ButtonStatic, classes.displayFlexPayment)}>
                                        <Space direction="horizontal" align="center" size={[10, 10]} className={clsx(classes.ButtonAbsolute, classes.OverallPaymentButton)}>
                                            <Button
                                                tabIndex={-1}
                                                key="confirm"
                                                onClick={() => handleConfirmSubmit()}
                                                color="primary"
                                                variant="contained"
                                                id={idNamingConversion('Confirm', 'supplierPayment', 'Button')}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >Confirm</Button>
                                            <Button
                                                tabIndex={-1}
                                                key="save"
                                                color="primary"
                                                variant="contained"
                                                type={'submit'}
                                                id={idNamingConversion('Save', 'supplierPayment', 'Button')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                            >Save</Button>
                                        </Space>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Supplier Name ", <span key={"Supplier Name"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Supplier Name' },
                                            { 'key': 'mobile', 'name': 'Phone Number' },
                                            { 'key': 'serialNo', 'name': 'Supplier ID' }]}
                                            details={supplierDetails}
                                            parentValue={customObject(supplierDetails, supplierId)}
                                            id={idNamingConversion('Supplier Name', 'supplierPayment', 'DropDown')}
                                            onChange={(data) => { handleChangeSupplier(data.id) }}
                                            parentError={errorSupplierId}
                                            searchType={(s) => supplierApi(s)}
                                            customClasses={classes.margin20t}
                                            position={"bottom"}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Supplier ID</InputLabel>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{supplierSerialNo || '---'}</Typography>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <div className={clsx(classes.margin25t, classes.dateAdjust)}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    fullWidth
                                                    error={errorDate && true}
                                                    helperText={errorDate}
                                                    slots={{
                                                        openPickerIcon: DateIcon
                                                    }}
                                                    views={['year', 'month', 'day']}
                                                    value={paymentDate}
                                                    label="Payment Date"
                                                    InputProps={{
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        }
                                                    }}
                                                    slotProps={{
                                                        textField: {
                                                            id: idNamingConversion('Payment Date', 'supplierPayment', 'TextField'),
                                                            autoComplete: 'one-time-code'
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        required: true
                                                    }}
                                                    format="dd/MM/yyyy"
                                                    onChange={(newValue) => { newValue !== null ? setPaymentDate(newValue) : setPaymentDate(new Date()) }}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Method of payment (MOP) ", <span key={"Method of payment (MOP)"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'method', 'name': 'Method' },
                                            { 'key': 'description', 'name': 'Description' }]}
                                            details={mopDetails}
                                            id={idNamingConversion('Method of payment', 'supplierPayment', 'DropDown')}
                                            parentValue={customObject(mopDetails, mopId)}
                                            onChange={(data) => setMopId(data.id)}
                                            position={"bottom"}
                                            customClasses={classes.margin25t}
                                            parentError={errorMopId}
                                        />
                                    </Col>
                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                        <AutoCompleteComponent
                                            name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                            heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                            { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                            details={currencyDetails}
                                            id={idNamingConversion('Currency', 'supplierPayment', 'DropDown')}
                                            parentValue={customObject(currencyDetails, currencyId)}
                                            onChange={(data) => setCurrencyId(data.id)}
                                            parentError={errorCurrency}
                                            position={"bottom"}
                                            customClasses={classes.margin25t}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label={["Payment Amount ", <span key={"Payment Amount"} className={classes.colorRedRequired}> *</span>]}
                                            fullWidth
                                            value={hiddenAmount}
                                            type="number"
                                            variant={'standard'}
                                            onWheel={(e) => e.target.blur()}
                                            error={errorAmount && true}
                                            helperText={errorAmount}
                                            id={idNamingConversion('Payment Amount', 'supplierPayment', 'DropDown')}
                                            className={clsx(classes.margin25t, { [classes.disabled]: selected && selected.length !== 0 })}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                            }}
                                            inputProps={{
                                                step: "any",
                                                "aria-autocomplete": "none"
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom
                                            }}
                                            onFocus={(e) => { parseFloat(e.target.value) === 0 ? handleAmount('') : handleAmount(parseFloat(e.target.value)) }}
                                            onBlur={(e) => { e.target.value === '' ? handleAmount(0) : handleAmount(parseFloat(e.target.value)) }}
                                            onChange={(e) => handleAmount(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label='Payment Reference (Optional)'
                                            fullWidth
                                            variant={'standard'}
                                            className={clsx(classes.margin25t)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Payment Reference', 'supplierPayment', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => setReference(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <TextField autoComplete='one-time-code'
                                            label='Description (Optional)'
                                            fullWidth
                                            variant={'standard'}
                                            className={clsx(classes.margin25t)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            id={idNamingConversion('Description', 'supplierPayment', 'TextField')}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </Col>
                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                        <InputLabel className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Payment Status</InputLabel>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{status !== '' ? capitalizeFirstLetter('CREATED') : '---'}</Typography>
                                    </Col>
                                </Row>
                            </Box>
                        }
                    />
                    <CustomAccordion
                        title={'Select Invoice'}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={false}
                        index={1}
                        ref={childRef}
                        component={
                            <div className={classes.tableRoot} style={{ height: "100%" }}>
                                <div className={classes.overFlowSelectiveAuto}>
                                    <Row gutter={20} align="middle" style={{ marginBottom: 8 }} className={classes.overFlowSelective}>
                                        <Col xxl={4} xl={4} lg={5} md={5} sm={5} xs={5}>
                                            <div id="autoMark" className={clsx(classes.disInline, classes.verticalAlignMiddle, classes.fontSize0)} dataamount={amount}>
                                                <Tooltip style={{ marginRight: 10 }}
                                                    classes={{ popper: clsx(classes.customToolTip) }}
                                                    title="Enable Auto Mark for the system to automatically select the Invoices" arrow
                                                    placement="top" className={clsx(classes.tooltip, classes.typographyHeaderToolTipCustom)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon} preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                            <div className={clsx(classes.disInline, classes.verticalAlignMiddle)}>
                                                <FormControlLabel
                                                    classes={{
                                                        label: clsx(classes.fonSize14, classes.textFieldLableAutoMark, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink'),

                                                    }}
                                                    control={<Switch size='small' className={clsx(classes.customSwitch, classes.marginLeft10)}
                                                        onChange={(e) => handleAutomark(e)}
                                                    />}
                                                    label="Auto Mark"
                                                    labelPlacement="start"
                                                    checked={autoMark}
                                                    disabled={hiddenAmount === 0 ? true : false}
                                                    className={clsx(classes.marginLeft0)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xxl={16} xl={16} lg={15} md={15} sm={15} xs={15} className={classes.textAlignCenter}>
                                            <div className={clsx(classes.amountBorder)}>
                                                <div className={clsx(classes.amountBorderCenterAlign)}>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Payment Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(paymentAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Marked Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(markedAmount)}</span></Typography>
                                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.paddingright0, classes.fonSize13)}>Balance Amnt: <span className={clsx(classes.textFieldColor, classes.bold, classes.fonSize14)}>₹ {currencyFormat(balanceAmount)}</span></Typography>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} className={classes.textAlignRight}>
                                            <Button
                                                key="confirm"
                                                type="submit"
                                                color="primary"
                                                variant="contained"
                                                className={clsx(classes.AddMoreBtn)}
                                                onClick={(e) => handleUnAutomark(e)}
                                            >Un-Mark</Button>
                                        </Col>
                                    </Row>
                                </div>
                                <CustomInfiniteScroll
                                    heads={selectPurchaseInvoiceHead}
                                    onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                                    sortOrder={sortOrder}
                                    width={true}
                                    loadMore={true}
                                    loadMoreContent={false}
                                    sortBy={sortBy}
                                    selected={selected}
                                    onSelected={(value) => setSelected(value)}
                                    component={
                                        <>
                                            {
                                                supplierId && loader === true ? (
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell className={classes.textAlignCenter} colSpan={8}><div className={classes.loadMoreCircle}></div></TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <React.Fragment>
                                                        {
                                                            loader === false && purchaseInvoiceDetails && purchaseInvoiceDetails.length > 0 ? purchaseInvoiceDetails.map((data, i) => (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={clsx({ [classes.disabled]: data?.onHold })} key={i}>
                                                                    <TableCell>
                                                                        {
                                                                            !data?.onHold ?
                                                                                <Checkbox checked={selected.find(e => e === data.id) ? true : false} id={`checkbox_${i}`}
                                                                                    className={clsx({ [classes.disabled]: amount === '' || data.billStatus === 'REVERSED' })} onChange={(e) => handleClick(e, data, i)} /> : ''
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 1) }}><span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 1) }}>{data?.serialNo}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 2) }}><span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 2) }}>{data?.supplierRefNum}</span></TableCell>
                                                                    <TableCell style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 3) }}><span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 3) }}>{moment(data.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 4) }}><span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 4) }}>₹ {data.invoiceAmount ? currencyFormat(data.invoiceAmount - data.settledAmount) : '0.00'}</span></TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 5) }}>
                                                                        <span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 6) }}><TextField autoComplete='one-time-code'
                                                                            fullWidth
                                                                            type={'number'}
                                                                            name="costAmount"
                                                                            value={data.costAmount && data.costAmount > 0 ? data.costAmount : (selected.find(e => e === data.id) ? "" : 0)}
                                                                            className={clsx(classes.textAreaAdjust, classes.dataCostAmount, { [classes.dataCostAmountText]: selected.find(e => e === data.id) })}
                                                                            // multiline={true}
                                                                            onChange={(e) => handleCostAmount(e, data, i)}
                                                                            InputProps={{
                                                                                startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                                classes: {
                                                                                    input: classes.textFieldColor,
                                                                                },
                                                                                step: "any"
                                                                            }}
                                                                            id={idNamingConversion('Cost Amount', 'supplierPayment', 'TextField')}
                                                                            onWheel={(e) => e.target.blur()}
                                                                            InputLabelProps={{
                                                                                className: classes.textAreaLableColorCustom,
                                                                            }}
                                                                        /></span>
                                                                    </TableCell>
                                                                    <TableCell className={classes.rightAlignAmount} style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 5) }}><span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 1) }}>₹ {data.invoiceAmount ? currencyFormat(parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2)) - parseFloat(data.costAmount)) : '0.00'}</span></TableCell>
                                                                    <TableCell className={clsx(classes.textAlignRight)} style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 6) }}>
                                                                        <span style={{ width: getColumnWidth(selectPurchaseInvoiceHead, 1) }}>  {data?.onHold ? <span style={{ display: "inline-block" }} className={clsx(classes.statusButton)}>Hold</span> :
                                                                            <span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.openButton]: data.costAmount === null || data.costAmount === 0 }, { [classes.fullButton]: (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) })}>
                                                                                {
                                                                                    (parseFloat(data.costAmount) === parseFloat(parseFloat(data.invoiceAmount - data.settledAmount).toFixed(2))) ? "Full" : data.costAmount === null || data.costAmount === 0 ? "Open" : "Partial"
                                                                                }
                                                                            </span>
                                                                        }
                                                                        </span>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : (
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell className={classes.textAlignCenter} colSpan={8}>
                                                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>Currently there is no open invoice to settle against payment</p>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </>
                                    }
                                />
                            </div>
                        }
                        lastContent={true}
                    />
                </div>
            </div >
            <Modal
                title={'System Override Confirmation'}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                    // onClick={() => deleteBill()}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => handleCancel()}
                    >
                        No
                    </Button>,
                ]}
            >
                <p>Do you want to override system selected Invoices to settle?</p>
            </Modal>

            <CustomModal
                visible={confirm}
                title='Payment Confirmation'
                yesButton={'Yes'}
                loading={createLoader}
                noButton='No'
                text={<p>Are you sure do you want to Confirm the Payment?</p>}
                onOpen={() => handleSubmit('', 'CONFIRMED')}
                onClose={() => setConfirm(false)}
            />
        </React.Fragment >
    )

}
export default SupplierPaymentCreate